module.exports = __webpack_public_path__ + "static/media/appImage1.8f743b7f.png";